import { render, staticRenderFns } from "./select-room-facility.vue?vue&type=template&id=c97a939a"
import script from "./select-room-facility.vue?vue&type=script&lang=ts"
export * from "./select-room-facility.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports